import Vue from "vue";

Vue.filter('time', function (value) {
    if (value==='') {
        return ''
    }
    if (value < 10) {
        return '0' + value
    }

    return value
})